exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2uWan{padding:0 0 32px;padding:0 0 2rem}._1FEBk{margin-bottom:16px;margin-bottom:1rem}._291Ka{width:100%}._2I_5b li{font-size:20px;font-size:1.25rem;font-weight:300;line-height:35.2px;line-height:2.2rem}", ""]);

// exports
exports.locals = {
	"root": "_2uWan",
	"heading": "_1FEBk",
	"mockup": "_291Ka",
	"features": "_2I_5b"
};